var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrialacc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130px",
    height: "111px",
    viewBox: "0 0 130 111",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.1359343,22.5577983 L94.1359343,81.8411008 C94.1359343,83.3751681 92.9895351,84.5481345 91.4911362,84.5481345 L2.64399816,84.5481345 C1.1455992,84.5481345 0,83.3751681 0,81.8411008 L0,22.5577983 C0,21.0245462 1.1455992,19.8507647 2.64399816,19.8507647 L91.4911362,19.8507647 C92.9895351,19.8507647 94.1359343,21.0245462 94.1359343,22.5577983 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.5%",
    y: "-34.8%",
    width: "166.9%",
    height: "197.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.396078431   0 0 0 0 0.478431373   0 0 0 0 0.576470588  0 0 0 0.18 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0229455256%",
    y1: "69.665594%",
    x2: "99.9728053%",
    y2: "69.665594%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2539D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.164851887%",
    y1: "43.5993976%",
    x2: "100.486922%",
    y2: "43.5993976%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.13455866%",
    y1: "49.2099323%",
    x2: "100.022691%",
    y2: "49.2099323%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.922704583%",
    y1: "56.05%",
    x2: "100.484042%",
    y2: "56.05%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.226904376%",
    y1: "49.9354839%",
    x2: "96.6936791%",
    y2: "49.9354839%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.13938412%",
    y1: "51.7586318%",
    x2: "98.6061588%",
    y2: "51.7586318%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.182433368%",
    y1: "49.8580348%",
    x2: "100.140044%",
    y2: "49.8580348%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "19.6914798%",
    y1: "31.23142%",
    x2: "75.1569507%",
    y2: "72.4253879%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81778",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E01F79",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.3039836%",
    y1: "84.705055%",
    x2: "11.4306908%",
    y2: "24.6489576%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC9E3",
    offset: "1.13208%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resellers",
    transform: "translate(-598.000000, -1132.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(616.000000, 1132.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2439671,97 C71.4375502,97 91.0511365,76.9218151 91.0511365,52.1542101 C91.0511365,27.386605 71.4375502,7.30842017 47.2439671,7.30842017 C23.0503839,7.30842017 3.4375976,27.386605 3.4375976,52.1542101 C3.4375976,76.9218151 23.0503839,97 47.2439671,97 Z",
    id: "Path",
    fill: "#EFF3FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.2239343,22.5577983 L94.2239343,25.6764706 L0.0879999386,25.6764706 L0.0879999386,22.5577983 C0.0879999386,21.0245462 1.23439914,19.8507647 2.73279809,19.8507647 L91.5799361,19.8507647 C92.9903351,19.8507647 94.2239343,21.0245462 94.2239343,22.5577983 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDFDFD",
    cx: 3.19999777,
    cy: 22.8235294,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDFDFD",
    opacity: 0.6,
    cx: 5.59999609,
    cy: 22.8235294,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDFDFD",
    opacity: 0.4,
    cx: 7.99999442,
    cy: 22.8235294,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0487546,80.7577983 L28.73438,80.7577983 C27.8527806,80.7577983 27.1479811,80.0364118 27.1479811,79.1340672 L27.1479811,32.3034454 C27.1479811,31.4011008 27.8527806,30.6788992 28.73438,30.6788992 L65.0487546,30.6788992 C65.930354,30.6788992 66.6351535,31.4011008 66.6351535,32.3034454 L66.6351535,79.1340672 C66.6351535,80.0364118 65.930354,80.7577983 65.0487546,80.7577983 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.611157,68.0353109 L32.5247773,68.0353109 C31.8191778,68.0353109 31.2903782,67.4940672 31.2903782,66.7718655 L31.2903782,47.8234454 C31.2903782,47.1012437 31.8191778,46.56 32.5247773,46.56 L61.5231571,46.56 C62.2279566,46.56 62.7575562,47.1012437 62.7575562,47.8234454 L62.7575562,66.7718655 C62.8455562,67.4940672 62.3167565,68.0353109 61.611157,68.0353109 Z",
    id: "Path",
    fill: "#E6EDF5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CED7E2",
    points: "48.3015663 65.1481345 34.8159757 65.1481345 41.603171 57.3881345"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "59.3199586 65.1481345 40.0167721 65.1481345 49.7119653 53.9588992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9287722,54.5001429 C41.3399712,54.5001429 42.4847704,53.3288067 42.4847704,51.8835882 C42.4847704,50.4383697 41.3399712,49.2670336 39.9287722,49.2670336 C38.5167731,49.2670336 37.3719739,50.4383697 37.3719739,51.8835882 C37.3719739,53.3288067 38.5167731,54.5001429 39.9287722,54.5001429 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1999378,80.0364118 L71.3071503,80.0364118 C70.8663506,80.0364118 70.5135508,79.6753109 70.5135508,79.2245462 L70.5135508,67.4940672 C70.5135508,67.0424874 70.8663506,66.6822017 71.3071503,66.6822017 L89.1999378,66.6822017 C89.6407375,66.6822017 89.9927372,67.0424874 89.9927372,67.4940672 L89.9927372,79.2245462 C89.9927372,79.6753109 89.6407375,80.0364118 89.1999378,80.0364118 Z",
    id: "Path",
    fill: "#E6EDF5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CED7E2",
    points: "80.9143436 78.2317227 72.7175493 78.2317227 76.8599464 73.4493782"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "87.7895388 78.2317227 75.8903471 78.2317227 81.795943 71.3740672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8023471,71.7351681 C76.6783465,71.7351681 77.388746,71.0080756 77.388746,70.1106218 C77.388746,69.2139832 76.6783465,68.4868908 75.8023471,68.4868908 C74.9263477,68.4868908 74.2159482,69.2139832 74.2159482,70.1106218 C74.2159482,71.0080756 74.9263477,71.7351681 75.8023471,71.7351681 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1999378,62.4411008 L71.3071503,62.4411008 C70.8663506,62.4411008 70.5135508,62.08 70.5135508,61.6292353 L70.5135508,49.8987563 C70.5135508,49.4471765 70.8663506,49.0868908 71.3071503,49.0868908 L89.1999378,49.0868908 C89.6407375,49.0868908 89.9927372,49.4471765 89.9927372,49.8987563 L89.9927372,61.6292353 C89.9927372,62.08 89.6407375,62.4411008 89.1999378,62.4411008 Z",
    id: "Path",
    fill: "#E6EDF5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CED7E2",
    points: "80.9143436 60.6364118 72.7175493 60.6364118 76.8599464 55.8540672"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "87.7895388 60.6364118 75.8903471 60.6364118 81.795943 53.6882773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8023471,54.0493782 C76.6783465,54.0493782 77.388746,53.3222857 77.388746,52.4248319 C77.388746,51.5281933 76.6783465,50.8011008 75.8023471,50.8011008 C74.9263477,50.8011008 74.2159482,51.5281933 74.2159482,52.4248319 C74.2159482,53.3222857 74.9263477,54.0493782 75.8023471,54.0493782 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1999378,44.7553109 L71.3071503,44.7553109 C70.8663506,44.7553109 70.5135508,44.3942101 70.5135508,43.9434454 L70.5135508,32.2129664 C70.5135508,31.7622017 70.8663506,31.4011008 71.3071503,31.4011008 L89.1999378,31.4011008 C89.6407375,31.4011008 89.9927372,31.7622017 89.9927372,32.2129664 L89.9927372,43.9434454 C89.9927372,44.3942101 89.6407375,44.7553109 89.1999378,44.7553109 Z",
    id: "Path",
    fill: "#E6EDF5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CED7E2",
    points: "80.9143436 42.9506218 72.7175493 42.9506218 76.8599464 38.1682773"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "87.7895388 42.9506218 75.8903471 42.9506218 81.795943 36.0929664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8023471,36.4540672 C76.6783465,36.4540672 77.388746,35.7269748 77.388746,34.829521 C77.388746,33.9328824 76.6783465,33.2057899 75.8023471,33.2057899 C74.9263477,33.2057899 74.2159482,33.9328824 74.2159482,34.829521 C74.2159482,35.7269748 74.9263477,36.4540672 75.8023471,36.4540672 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4927564,35.6422017 L31.7311779,35.6422017 C31.3783781,35.6422017 31.2023782,35.3707647 31.2023782,35.1001429 C31.2023782,34.7398571 31.4663781,34.5588992 31.7311779,34.5588992 L62.4047565,34.5588992 C62.7575562,34.5588992 62.9335561,34.829521 62.9335561,35.1001429 C63.021556,35.3707647 62.7575562,35.6422017 62.4927564,35.6422017 Z",
    id: "Path",
    fill: "#E6EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4927564,38.890479 L31.7311779,38.890479 C31.3783781,38.890479 31.2023782,38.6198571 31.2023782,38.3492353 C31.2023782,37.9881345 31.4663781,37.8071765 31.7311779,37.8071765 L62.4047565,37.8071765 C62.7575562,37.8071765 62.9335561,38.0777983 62.9335561,38.3492353 C63.021556,38.6198571 62.7575562,38.890479 62.4927564,38.890479 Z",
    id: "Path",
    fill: "#E6EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8551624,72.9081345 L31.7311779,72.9081345 C31.3783781,72.9081345 31.2023782,72.6375126 31.2023782,72.3668908 C31.2023782,72.0057899 31.4663781,71.8248319 31.7311779,71.8248319 L53.8551624,71.8248319 C54.2071622,71.8248319 54.3839621,72.0954538 54.3839621,72.3668908 C54.3839621,72.6375126 54.1191623,72.9081345 53.8551624,72.9081345 Z",
    id: "Path",
    fill: "#E6EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2439671,42.4093782 L31.7311779,42.4093782 C31.3783781,42.4093782 31.2023782,42.1387563 31.2023782,41.8681345 C31.2023782,41.5070336 31.4663781,41.3268908 31.7311779,41.3268908 L47.1559671,41.3268908 C47.5087669,41.3268908 47.6847667,41.5975126 47.6847667,41.8681345 C47.7727667,42.1387563 47.5087669,42.4093782 47.2439671,42.4093782 Z",
    id: "Path",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4927564,76.2468908 L31.7311779,76.2468908 C31.3783781,76.2468908 31.2023782,75.9754538 31.2023782,75.7048319 C31.2023782,75.3445462 31.4663781,75.1635882 31.7311779,75.1635882 L62.4047565,75.1635882 C62.7575562,75.1635882 62.9335561,75.4342101 62.9335561,75.7048319 C63.021556,75.9754538 62.7575562,76.2468908 62.4927564,76.2468908 Z",
    id: "Path",
    fill: "#E6EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4927564,72.9081345 L56.4991606,72.9081345 C56.1463608,72.9081345 55.970361,72.6375126 55.970361,72.3668908 C55.970361,72.0057899 56.2343608,71.8248319 56.4991606,71.8248319 L62.4927564,71.8248319 C62.8455562,71.8248319 63.021556,72.0954538 63.021556,72.3668908 C63.021556,72.6375126 62.7575562,72.9081345 62.4927564,72.9081345 Z",
    id: "Path",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1239846,80.4871765 L5.28879631,80.4871765 C4.23119705,80.4871765 3.4375976,79.6753109 3.4375976,78.5928235 L3.4375976,32.3034454 C3.4375976,31.2201429 4.23119705,30.4082773 5.28879631,30.4082773 L22.0351846,30.4082773 C23.0935839,30.4082773 23.8863833,31.2201429 23.8863833,32.3034454 L23.8863833,78.5928235 C23.9743833,79.6753109 23.0935839,80.4871765 22.1239846,80.4871765 Z",
    id: "Path",
    fill: "#1C3754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7503904,36.7246891 C14.8695896,36.7246891 15.777589,35.7954454 15.777589,34.6493782 C15.777589,33.5033109 14.8695896,32.5740672 13.7503904,32.5740672 C12.6303912,32.5740672 11.7231918,33.5033109 11.7231918,34.6493782 C11.7231918,35.7954454 12.6303912,36.7246891 13.7503904,36.7246891 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1847859,39.2515798 L7.3159949,39.2515798 C7.13919502,39.2515798 6.96319514,39.0706218 6.96319514,38.890479 C6.96319514,38.709521 7.13919502,38.5293782 7.3159949,38.5293782 L20.1847859,38.5293782 C20.3607858,38.5293782 20.5367857,38.709521 20.5367857,38.890479 C20.5367857,39.0706218 20.3607858,39.2515798 20.1847859,39.2515798 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1847859,42.0482773 L7.3159949,42.0482773 C7.13919502,42.0482773 6.96319514,41.8681345 6.96319514,41.6871765 C6.96319514,41.5070336 7.13919502,41.3268908 7.3159949,41.3268908 L20.1847859,41.3268908 C20.3607858,41.3268908 20.5367857,41.5070336 20.5367857,41.6871765 C20.5367857,41.8681345 20.3607858,42.0482773 20.1847859,42.0482773 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1847859,46.8306218 L7.3159949,46.8306218 C7.13919502,46.8306218 6.96319514,46.650479 6.96319514,46.469521 C6.96319514,46.1988992 7.05119508,46.0187563 7.3159949,46.0187563 L20.1847859,46.0187563 C20.3607858,46.0187563 20.5367857,46.1988992 20.5367857,46.3798571 C20.5367857,46.650479 20.3607858,46.8306218 20.1847859,46.8306218 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9871916,49.6281345 L7.13919502,49.6281345 C7.05119508,49.6281345 6.87519521,49.5376555 6.87519521,49.3575126 L6.87519521,49.0860756 C6.87519521,48.9964118 6.96319514,48.8154538 7.13919502,48.8154538 L11.8991917,48.8154538 C11.9871916,48.8154538 12.1639915,48.9059328 12.1639915,49.0860756 L12.1639915,49.3575126 C12.1639915,49.5376555 12.0751916,49.6281345 11.9871916,49.6281345 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1847859,54.5906218 L7.3159949,54.5906218 C7.13919502,54.5906218 6.96319514,54.410479 6.96319514,54.229521 C6.96319514,54.0493782 7.13919502,53.8692353 7.3159949,53.8692353 L20.1847859,53.8692353 C20.3607858,53.8692353 20.5367857,54.0493782 20.5367857,54.229521 C20.5367857,54.410479 20.3607858,54.5906218 20.1847859,54.5906218 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9871916,57.3881345 L7.13919502,57.3881345 C7.05119508,57.3881345 6.87519521,57.2976555 6.87519521,57.1175126 L6.87519521,56.8468908 C6.87519521,56.7564118 6.96319514,56.5754538 7.13919502,56.5754538 L11.8991917,56.5754538 C11.9871916,56.5754538 12.1639915,56.6659328 12.1639915,56.8468908 L12.1639915,57.1175126 C12.1639915,57.2976555 12.0751916,57.3881345 11.9871916,57.3881345 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1847859,62.3506218 L7.3159949,62.3506218 C7.13919502,62.3506218 6.96319514,62.170479 6.96319514,61.989521 C6.96319514,61.8093782 7.13919502,61.6292353 7.3159949,61.6292353 L20.1847859,61.6292353 C20.3607858,61.6292353 20.5367857,61.8093782 20.5367857,61.989521 C20.5367857,62.2601429 20.3607858,62.3506218 20.1847859,62.3506218 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9871916,65.1481345 L7.13919502,65.1481345 C7.05119508,65.1481345 6.87519521,65.0576555 6.87519521,64.8775126 L6.87519521,64.6068908 C6.87519521,64.5164118 6.96319514,64.3354538 7.13919502,64.3354538 L11.8991917,64.3354538 C11.9871916,64.3354538 12.1639915,64.4259328 12.1639915,64.6068908 L12.1639915,64.9671765 C12.1639915,65.0576555 12.0751916,65.1481345 11.9871916,65.1481345 Z",
    id: "Path",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3247426,17.3246891 C84.1743413,17.3246891 85.6743402,15.7898067 85.6743402,13.8954538 C85.6743402,12.001916 84.1743413,10.4670336 82.3247426,10.4670336 C80.4751449,10.4670336 78.9751449,12.001916 78.9751449,13.8954538 C78.9751449,15.7898067 80.4751449,17.3246891 82.3247426,17.3246891 Z",
    id: "Path",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9775854,7.30842017 C22.1951845,7.30842017 23.1815838,6.29847899 23.1815838,5.05296639 C23.1815838,3.80745378 22.1951845,2.79751261 20.9775854,2.79751261 C19.7607862,2.79751261 18.7743869,3.80745378 18.7743869,5.05296639 C18.7743869,6.29847899 19.7607862,7.30842017 20.9775854,7.30842017 Z",
    id: "Path",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9295924,13.0835882 C11.7567918,13.0835882 12.4279913,12.3972521 12.4279913,11.549521 C12.4279913,10.702605 11.7567918,10.0154538 10.9295924,10.0154538 C10.102393,10.0154538 9.43119342,10.702605 9.43119342,11.549521 C9.43119342,12.3972521 10.102393,13.0835882 10.9295924,13.0835882 Z",
    id: "Path",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4463453,2.88717647 C79.2255447,2.88717647 79.8567443,2.24078151 79.8567443,1.44358824 C79.8567443,0.646394958 79.2255447,0 78.4463453,0 C77.6679458,0 77.0359463,0.646394958 77.0359463,1.44358824 C77.0359463,2.24078151 77.6679458,2.88717647 78.4463453,2.88717647 Z",
    id: "Path",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4551899,96.4587563 C15.1367894,96.4587563 15.6895891,95.8930588 15.6895891,95.1953109 C15.6895891,94.497563 15.1367894,93.9318655 14.4551899,93.9318655 C13.7735904,93.9318655 13.2215908,94.497563 13.2215908,95.1953109 C13.2215908,95.8930588 13.7735904,96.4587563 14.4551899,96.4587563 Z",
    id: "Path",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.021556,3.24827731 C63.7031556,3.24827731 64.2559552,2.68257983 64.2559552,1.98483193 C64.2559552,1.28708403 63.7031556,0.722201681 63.021556,0.722201681 C62.3399565,0.722201681 61.7879569,1.28708403 61.7879569,1.98483193 C61.7879569,2.68257983 62.3399565,3.24827731 63.021556,3.24827731 Z",
    id: "Path",
    fill: "url(#linearGradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1055337,68.2154538 C94.576734,66.2306218 93.3423349,64.5164118 91.5799361,63.4331092 C89.6407375,62.2601429 87.6135389,62.08 85.4095404,61.8998571 C81.5311431,61.4482773 77.5647459,61.3577983 73.5983487,61.5387563 C70.0727511,61.6284202 66.018354,61.4482773 62.7575562,62.9823445 C58.0855595,65.0576555 57.4687599,69.6598571 57.29276,74.6223445 C57.1159602,78.3222017 57.1159602,82.7434454 58.0855595,86.3528235 C58.8791589,89.24 61.0823574,91.4954538 63.9911554,92.1271765 C67.6927528,93.029521 75.6255473,93.210479 79.5039446,93.12 C79.8567443,93.12 80.2095441,93.12 80.5615438,93.12 C83.6471417,93.029521 86.9079394,93.029521 89.7287374,91.9470336 C92.1087358,91.1351681 93.5191348,89.6907647 94.3999342,87.8860756 C95.4575334,85.7211008 95.7223332,83.0140672 95.8103332,80.0364118 C96.1631329,76.1564118 96.075133,71.7351681 95.1055337,68.2154538 Z",
    id: "Path",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.576734,87.7964118 C93.6951347,89.6011008 92.2847356,91.0446891 89.9047373,91.8565546 C86.9959393,92.8493782 83.7351416,92.9398571 80.7383437,93.029521 L72.2767496,84.3671765 L75.6255473,79.4046891 L83.7351416,76.6976555 L94.576734,87.7964118 Z",
    id: "Path",
    fill: "url(#linearGradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9239498,71.3740672 C71.9239498,70.0201429 72.6287493,69.5693782 73.7751485,70.2907647 C76.8599464,72.1859328 80.0327442,74.1707647 83.118342,76.0659328 C84.2639412,76.7881345 84.2639412,77.6 83.118342,78.4118655 C80.0327442,80.3070336 76.9479463,82.2918655 73.8631485,84.1870336 C72.6287493,84.9092353 72.0119498,84.5481345 71.9239498,83.2846891 C71.9239498,82.7434454 71.9239498,72.6375126 71.9239498,71.3740672 Z",
    id: "Path",
    fill: "url(#linearGradient-11)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrialacc);
export default __webpack_public_path__ + "static/media/trialacc.1be2b140ee93827967b97dc118e012a9.svg";
export { ForwardRef as ReactComponent };